import { render, staticRenderFns } from "./CK_two_column_fullbleed.vue?vue&type=template&id=217bff7a&"
import script from "./CK_two_column_fullbleed.vue?vue&type=script&lang=js&"
export * from "./CK_two_column_fullbleed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports